


export const large_number_clipper_old = (num:string)=>{

    let str_num = parseFloat(num).toFixed(3)
    let main_str_num = str_num.split('.')[0]
    if (main_str_num.length > 8) {
        let clipped_num = main_str_num.slice(0,7) + 'M'
        return  {clipped_num:clipped_num +' $',raw_num:main_str_num,trigger_tooltip:true}
    }
    return {clipped_num: str_num + ' $',raw_num:'',trigger_tooltip:false}
}

export const large_number_clipper = (num: string) => {
  const parsed = parseFloat(num);
 
  if (isNaN(parsed)) {
    return {
      clipped_num: "Invalid number",
      raw_num: "",
      trigger_tooltip: false
    };
  }

  const str = parsed.toString();
  const [intPart, decimalPart] = str.split(".");

  if (intPart.length > 8) {
    const clipped = intPart.slice(0, 7) + "…"; // ellipsis looks better than M
    return {
      clipped_num: clipped + " $",
      raw_num: str,
      trigger_tooltip: true
    };
  }

  return {
    clipped_num: parsed.toLocaleString(undefined, { maximumFractionDigits: 3 }) + " $",
    raw_num: "",
    trigger_tooltip: false
  };
};
